import { YStack, XStack, Text } from 'tamagui'
import type { ComparisonSlide as ComparisonSlideType } from '../../../content/decks/types'
import { SlideContainer, SlideInner, getAccentColor } from './shared'

export function ComparisonSlide({ slide }: { slide: ComparisonSlideType }) {
  const accentColor = getAccentColor(slide.accent)
  return (
    <SlideContainer>
      <SlideInner style={{ padding: 'clamp(24px, 4vw, 60px)' }}>
        <Text
          fontFamily="$heading"
          fontWeight="700"
          color={accentColor}
          style={{ fontSize: 'clamp(24px, 3.5vw, 44px)', lineHeight: '1.2em' }}
        >
          {slide.headline}
        </Text>
        <XStack
          gap="$4"
          marginTop="$4"
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          {/* Before panel */}
          <YStack
            flex={1}
            minWidth={280}
            backgroundColor="$cardBackground"
            borderRadius="$4"
            borderWidth={1}
            borderColor="#EF444440"
            overflow="hidden"
          >
            <YStack paddingHorizontal="$4" paddingVertical="$2" backgroundColor="#EF444415">
              <Text fontFamily="$mono" color="#EF4444" style={{ fontSize: 'clamp(10px, 1vw, 14px)' }}>
                {slide.before.label}
              </Text>
            </YStack>
            <YStack padding="$4">
              <Text
                tag="pre"
                fontFamily="$mono"
                color="$textMuted"
                style={{
                  fontSize: 'clamp(11px, 1.2vw, 15px)',
                  lineHeight: '1.6em',
                  whiteSpace: 'pre-wrap',
                  margin: 0,
                }}
              >
                {slide.before.content.replace(/\\n/g, '\n')}
              </Text>
            </YStack>
          </YStack>
          {/* After panel */}
          <YStack
            flex={1}
            minWidth={280}
            backgroundColor="$cardBackground"
            borderRadius="$4"
            borderWidth={1}
            borderColor={`${accentColor}40`}
            overflow="hidden"
          >
            <YStack paddingHorizontal="$4" paddingVertical="$2" backgroundColor={`${accentColor}15`}>
              <Text fontFamily="$mono" color={accentColor} style={{ fontSize: 'clamp(10px, 1vw, 14px)' }}>
                {slide.after.label}
              </Text>
            </YStack>
            <YStack padding="$4">
              <Text
                tag="pre"
                fontFamily="$mono"
                color="$textSecondary"
                style={{
                  fontSize: 'clamp(11px, 1.2vw, 15px)',
                  lineHeight: '1.6em',
                  whiteSpace: 'pre-wrap',
                  margin: 0,
                }}
              >
                {slide.after.content.replace(/\\n/g, '\n')}
              </Text>
            </YStack>
          </YStack>
        </XStack>
        {slide.verdict && (
          <Text
            fontFamily="$mono"
            color="$textMuted"
            fontStyle="italic"
            marginTop="$4"
            style={{ fontSize: 'clamp(12px, 1.5vw, 18px)' }}
          >
            {slide.verdict}
          </Text>
        )}
      </SlideInner>
    </SlideContainer>
  )
}
